module.exports = new __parcel__URL__("DACI.8156ef8f.svg").toString();